"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Color = void 0;
var Color;
(function (Color) {
    Color["Normal"] = "u-color-text";
    Color["White"] = "u-color-white";
    Color["Dark"] = "u-color-dark";
    Color["Light"] = "u-color-light";
    Color["Link"] = "u-color-link";
    Color["PrimaryBrand"] = "u-color-1";
    Color["SecondaryBrand"] = "u-color-2";
    Color["TertiaryBrand"] = "u-color-3";
    Color["Positive"] = "u-color-pos";
    Color["Negative"] = "u-color-neg";
    Color["Warning"] = "u-color-warn";
    Color["DarkMode"] = "s-dark";
    Color["LightMode"] = "s-light";
    Color["WhiteAll"] = "u-color-white-all";
    Color["DarkAll"] = "u-color-dark-all";
})(Color = exports.Color || (exports.Color = {}));
//# sourceMappingURL=Color.js.map